import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRecipientSelect = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		opacity: .5,
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M19.5 20V19C19.5 16.7909 17.7091 15 15.5 15H9.5C7.29086 15 5.5 16.7909 5.5 19V20",
			stroke: "black",
			strokeWidth: 1.5
		}), /* @__PURE__ */ _jsx("circle", {
			cx: 12.5,
			cy: 8,
			r: 4,
			stroke: "black",
			strokeWidth: 1.5
		})]
	})
});
export default SvgRecipientSelect;
